<div
  class="course-archive-progress-chart-container  course-archive-progress-chart-wrapper-{{
    field
  }}"
>
  <div class="course-archive-progress-chart-wrapper">
    <div #chart></div>
  </div>
  <div class="course-archive-progress-content-container">
    <h2 class="course-archive-progress-content-title">
      {{ field | translation }}
    </h2>
    <div class="course-archive-progress-content-wrapper">
      <p
        class="course-archive-progress-content-stat"
        *ngIf="!isLoading; else loading"
      >
        <ng-container *ngIf="!hasError">
          {{ stat | number }}
        </ng-container>
        <ng-container *ngIf="hasError"> Error Loading</ng-container>
      </p>
      <ng-template #loading>
        <div class="dots">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      </ng-template>
    </div>
  </div>
</div>
